<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <h3>Site Analytics</h3>
    <div v-if="this.loading" class="text-center">
      <b-spinner class="align-middle mx-2 " variant="primary"></b-spinner>
    </div>
    <div v-else>
      <div class="ml-2 bg-white p-3 rounded">
        <table class="table table-bordered" style="
        table-layout: fixed; border-radius: 10px">
          <thead class="p-2">
          </thead>
          <tbody>
          <tr>
            <th colspan="4">
              <a>Analytics Data</a>
            </th>
          </tr>

          <tr>
            <td colspan="2">
              <span style="font-size: small">Total Users</span>
            </td>
            <td colspan="2">
              <span style="font-size: small">Total Active Users</span>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <span style="font-size: small">{{ totalUser }}</span>
            </td>
            <td colspan="2">
              <span style="font-size: small">{{ activeUser }}</span>
            </td>
          </tr>
          <tr>
            <th colspan="3" data-tooltip="Page Title">Title</th>
            <th colspan="1" data-tooltip="Pageviews">Pageviews</th>
          </tr>
          <tr v-for="(item, index) in pageViewList" :key="index">
            <td colspan="3">
              <div>
                <div>
                  <a class="h4" href="">{{ item.pagePath }}</a><br/>
                </div>
                <div class="mt-4">
                  <a :href="portalUrl+item.fullPageUrl" target="_blank">{{ portalUrl + item.fullPageUrl }}</a>
                </div>
              </div>
            </td>
            <td colspan="1">
              <div>
                <span>{{ item.pageView }}</span>
              </div>
            </td>
          </tr>

          </tbody>
        </table>
      </div>
      <div class="bg-white ml-2 mt-5 rounded">
        <div class="row">
          <div class="col-md-12 p-3">
            <Bar :data="data" :options="options"/>
          </div>
          <!--<div class="col-md-6 p-3" >
              <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-danger"
                      active-tab-class="font-weight-bold text-success" content-class="mt-3">
                  <b-tab title="First" @click="showDeviceChart=1" active><p>I'm the first tab</p></b-tab>
                  <b-tab title="Second" @click="showDeviceChart=2"><p>I'm the second tab</p></b-tab>
              </b-tabs>
              <pre>{{deviceData}}</pre>
              <div>
                  <div class="mt-5" style="width: 500px;height: 400px;">

                      <Doughnut :data="deviceData" :options="deviceOptions"/>
                  </div>
              </div>

              &lt;!&ndash;<Bar :data="data" :options="options"/>&ndash;&gt;
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import { notify } from "@kyvg/vue3-notification";
import dashboard from "@/services/dashboard.service";
import {ArcElement, BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip} from 'chart.js'
import {Bar} from 'vue-chartjs';

/*import {ArcElement, Chart as ChartJS, Legend, Tooltip} from 'chart.js'
import {Pie, Doughnut} from 'vue-chartjs'
import moment from 'moment';

ChartJS.register(ArcElement, Tooltip, Legend)*/
ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

export default {
  components: {
    Bar,
    /*Doughnut*/
  },
  setup() {
  },
  data() {
    return {
      loading: false,
      data: {
        labels: [],
        datasets: [{
          label: "New Visitor's (Last 15 Day's)",
          backgroundColor: '#f87979',
          data: []
        }]
      },
      deviceData: {
        labels: [],
        datasets: [{
          label: [],
          backgroundColor: [],
          data: []
        }],
        enableRtl: 'true',
      },
      portalUrl: process.env.VUE_APP_PORTAL_URL,
      deviceTotalData: [],
      deviceArrayName: [],
      deviceArrayValue: [],
      cityArray: [],
      totalUser: 0,
      deviceOptions: [],
      activeUser: 0,
      newUserList: [],
      pageViewList: [],
      userDate: [],
      userCount: [],
      showDeviceChart: 1,
      itemsBread: [
        {
          text: 'Home',
          to: 'dashboard'
        }, {
          text: 'Site Analytics',
          href: '#'
        }],
    };
  },
  options: {
    responsive: true
  },
  async created() {
    await this.getGoogleData();
    await this.getGoogleRealTimeData();
  },
  methods: {
    async getGoogleData() {
      try {
        this.loading = true;
        const response = await dashboard.googleData();
        this.loading = false;
        if (response.data) {
          this.totalUser = response.data.totalUsers ? response.data.totalUsers : 0;
          this.newUserList = response.data.newUserList;
          this.pageViewList = response.data.pageViewsList;
          this.deviceTotalData = response.data.usersPerDeviceList;
          this.deviceTotalData = response.data.usersPerDeviceList;
          /*for (var i = 0; i < this.deviceTotalData.length; i++) {
              this.deviceArrayName.push(this.deviceTotalData[i].deviceCategory);
              this.deviceArrayValue.push(this.deviceTotalData[i].users);
          }*/
          this.data = this.generateChartData(this.newUserList);
          //this.deviceData=this.generateDeviceChartData(this.deviceArrayName,this.deviceArrayValue);
        }
      } catch (e) {
        this.loading = false;
        console.log(e);
      }
    },
    generateChartData(data) {
      const labels = [];
      const newData = [];
      data.forEach(entry => {
        labels.push(entry.date);
        newData.push(parseInt(entry.newUsers));
      });
      const chartData = {
        labels: labels,
        datasets: [
          {
            label: "New Visitor's (Last 15 Day's)",
            backgroundColor: '#f87979',
            data: newData
          }
        ]
      };
      return chartData;
    },
    async getGoogleRealTimeData() {
      // console.log("console Data", Config);
      try {
        this.loading = true;
        const response = await dashboard.googleRealTimeData();
        this.loading = false;
        if (response.data) {
          this.activeUser = response.data.activeUsers ? response.data.activeUsers : 0;
          /*notify({
              type: "success",
              title: "Delete Post",
              text: response.data.message,
          });*/
        }
      } catch (e) {
        this.loading = false;
        console.log(e);
      }
    },
    generateDeviceChartData(label, data) {
      const labels = label;
      this.deviceData = {
        labels: labels,
        datasets: [
          {
            label: 'Total',
            backgroundColor: ['#41B883'],
            data: data
          }
        ]
      };
      this.deviceOptions = {
        responsive: true,
        maintainAspectRatio: false
      };
      //console.log("DAtA",this.deviceData)
    },

  },
};
</script>
<style scoped>
tr.withBorder td {
  border: 1px solid black;
}

td {
  column-span: 1;
}
</style>
